"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _Functions = require("../core/Functions");

var _RootNode = require("../utils/RootNode");

var _component = _interopRequireDefault(require("../utils/propTypes/component"));

var _domElement = _interopRequireDefault(require("../utils/propTypes/domElement"));

var _PortalLayer = _interopRequireDefault(require("./internal/PortalLayer"));

var _SubtreeLayer = _interopRequireDefault(require("./internal/SubtreeLayer"));

var _ClickableContext = require("../context/ClickableContext");

var UILayer =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(UILayer, _React$Component);

  function UILayer(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UILayer);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UILayer).call(this, props));
    _this._rootNode = props.rootNode || (0, _RootNode.getDefaultNode)();
    _this._element = document.createElement('div');
    _this._element.className = 'private-layer';

    _this._element.setAttribute('data-layer-for', props['data-layer-for']);

    _this._rootNode.appendChild(_this._element);

    _this.handleCloseComplete = _this.handleCloseComplete.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderTree = _this.renderTree.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(UILayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      setTimeout(function () {
        var layerFor = _this2.props['data-layer-for'];
        if (_this2._clickableContext) _this2._clickableContext(layerFor);
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var Transition = this.props.Transition;
      if (!Transition) this.handleCloseComplete();
    }
  }, {
    key: "handleCloseComplete",
    value: function handleCloseComplete() {
      var _this$props = this.props,
          onCloseComplete = _this$props.onCloseComplete,
          transitionProps = _this$props.transitionProps;
      (0, _Functions.callIfPossible)(transitionProps && transitionProps.onCloseComplete);
      (0, _Functions.callIfPossible)(onCloseComplete);

      if (!_reactDom.default.createPortal) {
        _reactDom.default.unmountComponentAtNode(this._element);
      }

      this._rootNode.removeChild(this._element);
    }
  }, {
    key: "renderTree",
    value: function renderTree(content, forceTransitionOnMount) {
      var _this$props2 = this.props,
          Transition = _this$props2.Transition,
          transitionProps = _this$props2.transitionProps;
      if (!Transition) return content;
      return _react.default.createElement(Transition, (0, _extends2.default)({}, transitionProps, {
        onCloseComplete: this.handleCloseComplete,
        transitionOnMount: forceTransitionOnMount || transitionProps && transitionProps.transitionOnMount
      }), content);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var children = this.props.children;
      var LayerRenderer = _reactDom.default.createPortal ? _PortalLayer.default : _SubtreeLayer.default;
      return _react.default.createElement(_ClickableContext.ClickableContextConsumer, null, function (clickableContext) {
        _this3._clickableContext = clickableContext;
        return _react.default.createElement(LayerRenderer, {
          element: _this3._element,
          renderTree: _this3.renderTree
        }, children);
      });
    }
  }]);
  return UILayer;
}(_react.default.Component);

UILayer.propTypes = {
  children: _react.PropTypes.node.isRequired,
  'data-layer-for': _react.PropTypes.string,
  onCloseComplete: _react.PropTypes.func,
  rootNode: _domElement.default,
  Transition: _component.default,
  transitionProps: _react.PropTypes.object
};
UILayer.displayName = 'UILayer';
var _default = UILayer;
exports.default = _default;
module.exports = exports.default;